<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ isView ? "View " : $route.params.id ? "Edit " : "Add " }} School
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <fieldset :disabled="isView">
      <form @submit.prevent="saveSchool">
        <!-- Details -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0"><h3>Details</h3></div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Logo 1</label>
                    <div class="row align-items-center">
                      <div class="col-4 pr-0">
                        <img
                          :src="logo1 ? logo1 : '/static/no-preview.jpg'"
                          style="width: 82.5%"
                          id="previewLogo1"
                        />
                        <button
                          v-if="logo1"
                          id="removeLogo1"
                          title="Remove Logo 1"
                          @click="removeLogo1"
                          class="btn p-0"
                        >
                          <i class="fa fa-trash" style="color: grey"></i>
                        </button>
                      </div>
                      <div class="col-8 pl-lg-0">
                        <div class="note">
                          Recommended logo dimensions: 100 x 100px
                        </div>
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            accept="image/*"
                            id="customFileLogo1"
                            ref="customFileLogo1"
                            @change="onLogo1Selected($event)"
                          />
                          <label
                            class="custom-file-label"
                            for="customFileLogo1"
                          >
                            {{ fileNameLogo1 }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Logo 2</label>
                    <div class="row align-items-center">
                      <div class="col-4 pr-0">
                        <img
                          :src="logo2 ? logo2 : '/static/no-preview.jpg'"
                          style="width: 82.5%"
                          id="previewLogo2"
                        />
                        <button
                          v-if="logo2"
                          id="removeLogo2"
                          title="Remove Logo 2"
                          @click="removeLogo2"
                          class="btn p-0"
                        >
                          <i class="fa fa-trash" style="color: grey"></i>
                        </button>
                      </div>
                      <div class="col-8 pl-lg-0">
                        <div class="note">
                          Recommended logo dimensions: 100 x 100px
                        </div>
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            accept="image/*"
                            id="customFileLogo2"
                            ref="customFileLogo2"
                            @change="onLogo2Selected($event)"
                          />
                          <label
                            class="custom-file-label"
                            for="customFileLogo2"
                          >
                            {{ fileNameLogo2 }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Code<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="code"
                      class="form-control"
                      placeholder="Input Company Code Here"
                      maxlength="20"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Name<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="name"
                      class="form-control"
                      placeholder="Input Company Name Here"
                      maxlength="100"
                      required
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Admin</label>
                    <input
                      type="text"
                      v-model="admin"
                      class="form-control"
                      maxlength="100"
                      placeholder="Input Admin Here"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      v-model="contactNumber"
                      class="form-control"
                      maxlength="20"
                      placeholder="Input Contact Number Here"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Details -->

        <!-- Address -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0"><h3>Address</h3></div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th class="no-col">#</th>
                        <th class="type-col">Type</th>
                        <th class="street-col">Street 1</th>
                        <th class="street-col">Street 2</th>
                        <th class="city-col">City</th>
                        <th class="postcode-col">Postcode</th>
                        <th class="country-col">Country</th>
                        <th class="action-col">
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="addAddress"
                          >
                            <i class="fa fa-plus" title="Add Address"></i>
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(address, i) in addresses" :key="i">
                        <td class="no-col">{{ i + 1 }}</td>
                        <td class="type-col">
                          <select
                            v-model="address.AddressTypeId"
                            class="form-control form-control-sm"
                            required
                            @change="onChangeAddressType($event, i)"
                          >
                            <option
                              v-for="item in addressTypes"
                              :value="item.Id"
                              :key="item.Id"
                            >
                              {{ item.Name }}
                            </option>
                          </select>
                          <input
                            type="text"
                            v-model="address.AddressTypeOther"
                            class="form-control form-control-sm mt-2"
                            required
                            maxlength="50"
                            v-if="address.ShowAddressTypeOther"
                          />
                        </td>
                        <td class="street-col">
                          <textarea
                            type="text"
                            v-model="address.Street1"
                            class="form-control"
                            placeholder="Street"
                            required
                            maxlength="100"
                          ></textarea>
                        </td>
                        <td class="street-col">
                          <textarea
                            type="text"
                            v-model="address.Street2"
                            class="form-control"
                            placeholder="Street"
                            maxlength="100"
                          ></textarea>
                        </td>
                        <td class="city-col">
                          <input
                            type="text"
                            v-model="address.City"
                            class="form-control form-control-sm"
                            placeholder="City"
                            maxlength="50"
                          />
                        </td>
                        <td class="postcode-col">
                          <input
                            type="text"
                            v-model="address.Postcode"
                            class="form-control form-control-sm"
                            placeholder="Postcode"
                            maxlength="20"
                          />
                        </td>
                        <td class="country-col">
                          <select
                            v-model="address.CountryId"
                            class="form-control form-control-sm"
                            required
                          >
                            <option
                              v-for="item in countries"
                              :value="item.Id"
                              :key="item.Id"
                            >
                              {{ item.Name }}
                            </option>
                          </select>
                        </td>
                        <td class="action-col">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="removeAddress(i)"
                          >
                            <i class="fa fa-trash-o" title="Remove Address"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Address -->

        <!-- Government and Payment Related -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Government and Payment Related</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>
                      UEN(Unique Entity Number) Account 1
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="uen1"
                      class="form-control"
                      placeholder="Input UEN Account 1"
                      maxlength="20"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      UEN(Unique Entity Number) Account 2 - (Optional)
                    </label>
                    <input
                      type="text"
                      v-model="uen2"
                      class="form-control"
                      placeholder="Input UEN Account 2 (Optional)"
                      maxlength="20"
                    />
                  </div>
                </div>
                <div class="form-row mb-4">
                  <div class="col-md-2 fit-content">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="chkTaxRegistered"
                        v-model="isSalesTaxRegistered"
                      />
                      <label class="form-check-label" for="chkTaxRegistered">
                        Sales tax registered
                      </label>
                    </div>
                  </div>
                  <div
                    class="col-md-3 mt-2 mt-md-0 mt-lg-0"
                    v-if="isSalesTaxRegistered"
                  >
                    <select
                      class="form-control form-control-sm"
                      required
                      v-model="salesTaxId"
                      @change="onChangeSalesTax($event)"
                    >
                      <option value>-- Select Sales Tax --</option>
                      <option
                        v-for="item in salesTaxes"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-md-3 mt-2 mt-md-0 mt-lg-0"
                    v-if="isSalesTaxRegistered && showSalesTaxOther"
                  >
                    <input
                      type="text"
                      v-model="salesTaxOther"
                      class="form-control form-control-sm"
                      placeholder="Input Others Sales Tax"
                      maxlength="20"
                      required
                    />
                  </div>
                  <div
                    class="col-md-4 mt-2 mt-md-0 mt-lg-0"
                    v-if="isSalesTaxRegistered && salesTaxId"
                  >
                    <input
                      type="number"
                      v-model="salesTaxPercentage"
                      class="form-control form-control-sm"
                      :placeholder="salesTaxPercentagePlaceholder"
                      min="0.01"
                      step="0.01"
                      max="100"
                      required
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12"><h4>Upload Payment QR Code</h4></div>
                </div>
                <div class="form-row mb-4">
                  <div class="form-group col-md-6">
                    <label>QR Code 1</label>
                    <div class="row align-items-center">
                      <div class="col-4 pr-0">
                        <img
                          :src="qrCode1 ? qrCode1 : '/static/no-preview.jpg'"
                          style="width: 82.5%"
                          id="previewQrCode1"
                        />
                        <button
                          v-if="qrCode1"
                          id="removeQrCode1"
                          title="Remove QR Code 1"
                          @click="removeQrCode1"
                          class="btn p-0"
                        >
                          <i class="fa fa-trash" style="color: grey"></i>
                        </button>
                      </div>
                      <div class="col-8 pl-lg-0">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            accept="image/*"
                            id="customFileQrCode1"
                            ref="customFileQrCode1"
                            @change="onQrCode1Selected($event)"
                          />
                          <label
                            class="custom-file-label"
                            for="customFileQrCode1"
                          >
                            {{ fileNameQrCode1 }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>QR Code 2</label>
                    <div class="row align-items-center">
                      <div class="col-4 pr-0">
                        <img
                          :src="qrCode2 ? qrCode2 : '/static/no-preview.jpg'"
                          style="width: 82.5%"
                          id="previewQrCode2"
                        />
                        <button
                          v-if="qrCode2"
                          id="removeQrCode2"
                          title="Remove QR Code 2"
                          @click="removeQrCode2"
                          class="btn p-0"
                        >
                          <i class="fa fa-trash" style="color: grey"></i>
                        </button>
                      </div>
                      <div class="col-8 pl-lg-0">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            accept="image/*"
                            id="customFileQrCode2"
                            ref="customFileQrCode2"
                            @change="onQrCode2Selected($event)"
                          />
                          <label
                            class="custom-file-label"
                            for="customFileQrCode2"
                          >
                            {{ fileNameQrCode2 }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-12">
                    <h4>Electronic Bank Transfer Details</h4>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>
                      SWIFT Code
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="swiftCode"
                      class="form-control"
                      placeholder="Input SWIFT Code"
                      maxlength="20"
                      required
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>
                      Account Number
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="accountNumber"
                      class="form-control"
                      placeholder="Input Account Number"
                      maxlength="50"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      Account Name
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="accountName"
                      class="form-control"
                      placeholder="Input Account Name"
                      maxlength="100"
                      required
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>
                      Bank Name
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="bankName"
                      class="form-control"
                      placeholder="Input Bank Name"
                      maxlength="100"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      Bank Address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="bankAddress"
                      class="form-control"
                      placeholder="Input Bank Address"
                      maxlength="200"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Government and Payment Related -->

        <!-- Others -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Others</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Status</label>
                    <select v-model="status" class="form-control" required>
                      <option value="Active" selected>Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Remarks - (Optional)</label>
                    <textarea
                      class="form-control"
                      v-model="remarks"
                      maxlength="500"
                      placeholder="Input Remarks Here"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Others -->

        <!-- Button -->
        <div class="text-center" v-if="!isView">
          <router-link class="btn btn-danger mr-4" :to="{ name: 'schoolList' }">
            Cancel
          </router-link>
          <button class="btn btn-primary" type="submit">
            {{ $route.params.id ? "Update " : "Add " }}
          </button>
        </div>
        <!-- /Button -->
      </form>
    </fieldset>
    <!-- Button Back -->
    <div class="text-center" v-if="isView">
      <router-link class="btn btn-primary" :to="{ name: 'schoolList' }">
        <i class="fa fa-reply mr-2"></i>Back to Schools
      </router-link>
    </div>
    <!-- /Button Back -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      logo1: null,
      logo2: null,
      code: "",
      name: "",
      admin: "",
      contactNumber: "",
      addresses: [
        {
          Id: "",
          AddressTypeId: "",
          ShowAddressTypeOther: false,
          AddressTypeOther: "",
          Street1: "",
          Street2: "",
          City: "",
          Postcode: "",
          CountryId: "",
          SortOrder: "",
        },
      ],
      addressTypes: [],
      countries: [],
      uen1: "",
      uen2: "",
      qrCode1: null,
      qrCode2: null,
      status: "Active",
      remarks: "",
      fileNameLogo1: "Upload School Logo 1",
      fileNameLogo2: "Upload School Logo 2",
      fileNameQrCode1: "Upload Payment QR Code 1",
      fileNameQrCode2: "Upload Payment QR Code 2",
      isSalesTaxRegistered: "",
      salesTaxes: [],
      salesTaxId: "",
      showSalesTaxOther: false,
      salesTaxOther: "",
      salesTaxPercentage: null,
      swiftCode: "",
      accountNumber: "",
      accountName: "",
      bankName: "",
      bankAddress: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
    salesTaxPercentagePlaceholder() {
      let placeholder = "Input Percentage";
      let salesTaxId = this.salesTaxId;
      let salesTax = this.salesTaxes.find((c) => c.Id == salesTaxId);
      let salesTaxName = "";
      if (salesTax)
        salesTaxName =
          salesTax.Name == "Others" ? this.salesTaxOther : salesTax.Name;
      if (salesTaxName) placeholder = "Input " + salesTaxName + " Percentage";
      return placeholder;
    },
    isView() {
      return this.$route.path.includes("/show");
    },
  },
  methods: {
    //for image upload
    removeLogo1() {
      this.logo1 = null;
      this.$refs.customFileLogo1.value = null;
      this.fileNameLogo1 = "Upload School Logo 1";
    },
    removeLogo2() {
      this.logo2 = null;
      this.$refs.customFileLogo2.value = null;
      this.fileNameLogo2 = "Upload School Logo 2";
    },
    removeQrCode1() {
      this.qrCode1 = null;
      this.$refs.customFileQrCode1.value = null;
      this.fileNameQrCode1 = "Upload Payment QR Code 1";
    },
    removeQrCode2() {
      this.qrCode2 = null;
      this.$refs.customFileQrCode2.value = null;
      this.fileNameQrCode2 = "Upload Payment QR Code 2";
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    onLogo1Selected(event) {
      const file = event.target.files[0];
      this.fileNameLogo1 = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.logo1 = result;
      });
    },
    onLogo2Selected(event) {
      const file = event.target.files[0];
      this.fileNameLogo2 = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.logo2 = result;
      });
    },
    onQrCode1Selected(event) {
      const file = event.target.files[0];
      this.fileNameQrCode1 = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.qrCode1 = result;
      });
    },
    onQrCode2Selected(event) {
      const file = event.target.files[0];
      this.fileNameQrCode2 = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.qrCode2 = result;
      });
    },
    //for dropdown
    getAddressTypesForSchool() {
      API.school
        .getAddressTypesForSchool({ Token: this.token })
        .then((response) => {
          if (response.data.success) {
            this.addressTypes = response.data.data;
            if (!this.$route.params.id)
              this.addresses[0].AddressTypeId = this.addressTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getCountries() {
      API.common
        .getCountries({ Token: this.token })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            if (!this.$route.params.id)
              this.addresses[0].CountryId = this.countries.find(
                (c) => c.Name == "Singapore"
              ).Id;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for sales tax
    getSalesTaxes() {
      API.common
        .getSalesTaxes({ Token: this.token })
        .then((response) => {
          if (response.data.success) {
            this.salesTaxes = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSalesTax(event) {
      let salesTaxId = event.target.value;
      let salesTax = this.salesTaxes.find((c) => c.Id == salesTaxId);
      let salesTaxName = "";
      if (salesTax) salesTaxName = salesTax.Name;
      this.showSalesTaxOther = salesTaxName == "Others";
    },
    //for address
    addAddress() {
      this.addresses.push({
        Id: "",
        AddressTypeId: this.addressTypes[0].Id,
        ShowAddressTypeOther: false,
        AddressTypeOther: "",
        Street1: "",
        Street2: "",
        City: "",
        Postcode: "",
        CountryId: this.countries.find((c) => c.Name == "Singapore").Id,
        SortOrder: "",
      });
    },
    removeAddress(index) {
      this.addresses.splice(index, 1);
    },
    onChangeAddressType(event, index) {
      let addressTypeId = event.target.value;
      let addressType = this.addressTypes.find(
        (c) => c.Id == addressTypeId
      ).Name;
      this.addresses[index].ShowAddressTypeOther = addressType == "Other";
    },
    //main function
    saveSchool() {
      if (this.addresses.length == 0) {
        this.$swal("Please add at least 1 address", { icon: "error" });
        return;
      }

      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        Logo1: this.logo1,
        Logo2: this.logo2,
        Code: this.code,
        Name: this.name,
        Admin: this.admin,
        ContactNumber: this.contactNumber,
        Addresses: this.addresses,
        UEN1: this.uen1,
        UEN2: this.uen2,
        QRCode1: this.qrCode1,
        QRCode2: this.qrCode2,
        Status: this.status,
        Remarks: this.remarks,
        IsSalesTaxRegistered: this.isSalesTaxRegistered,
        SalesTaxId: this.salesTaxId,
        ShowSalesTaxOther: this.showSalesTaxOther,
        SalesTaxOther: this.salesTaxOther,
        SalesTaxPercentage: this.salesTaxPercentage,
        SwiftCode: this.swiftCode,
        AccountNumber: this.accountNumber,
        AccountName: this.accountName,
        BankName: this.bankName,
        BankAddress: this.bankAddress,
      };
      let action = this.$route.params.id ? "update" : "add";
      let text = `Are you sure you want to ${action} the school?`;
      this.$swal({
        title: "Are you sure?",
        text: text,
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.school
            .saveSchool(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success)
                this.$router.replace({ name: "schoolList" });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getSchoolDetail() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.school
        .getSchoolDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let school = response.data.data;
            this.logo1 = school.Logo1;
            this.logo2 = school.Logo2;
            this.code = school.Code;
            this.name = school.Name;
            this.admin = school.Admin;
            this.contactNumber = school.ContactNumber;
            this.addresses = school.Addresses;
            this.uen1 = school.UEN1;
            this.uen2 = school.UEN2;
            this.qrCode1 = school.QRCode1;
            this.qrCode2 = school.QRCode2;
            this.status = school.Status;
            this.remarks = school.Remarks;
            this.isSalesTaxRegistered = school.IsSalesTaxRegistered;
            this.salesTaxId = school.SalesTaxId;
            this.showSalesTaxOther = school.ShowSalesTaxOther;
            this.salesTaxOther = school.SalesTaxOther;
            this.salesTaxPercentage = school.SalesTaxPercentage;
            this.swiftCode = school.SwiftCode;
            this.accountNumber = school.AccountNumber;
            this.accountName = school.AccountName;
            this.bankName = school.BankName;
            this.bankAddress = school.BankAddress;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getAddressTypesForSchool();
    this.getCountries();
    this.getSalesTaxes();
    if (this.$route.params.id) this.getSchoolDetail();
  },
};
</script>

<style scoped>
.no-col {
  width: 40px;
  vertical-align: middle;
}
.action-col {
  width: 64px;
}
.type-col {
  width: 150px;
}
.postcode-col {
  width: 110px;
}
.form-check-label {
  margin-top: 2px;
}
.table-responsive {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/MainAdmin/SchoolEdit.vue